import React from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Icon} from '@iconify/react';
import Button from '../../incase-domain/components/button/Button';
import {errorMessageSelector, errorStatusSelector} from '../../store/selectors/error.selectors';

function ErrorReport(): JSX.Element {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const status = useSelector(errorStatusSelector);
    const message = useSelector(errorMessageSelector);

    return (
        <>
            <main className="c-errorReport">
                <div className="c-errorReport__oval" />
                <Icon className="c-errorReport__icon" icon="streamline-emojis:satellite-antenna" />
                <div className="c-errorReport__title">{status}</div>
                <div className="c-errorReport__description">{message}</div>
                <Button
                    className="c-errorReport__button"
                    variant="solid"
                    size="xl"
                    wide
                    color="info"
                    onClick={() => {
                        navigate(0);
                    }}
                >
                    {t('navigation.refresh')}
                </Button>
            </main>
        </>
    );
}

export default ErrorReport;
